
###
# Order model
###
App.Message = DS.Model.extend()
